module.exports = __webpack_public_path__ + "img/3-5.89774c1e.svg";